import {
  IReservationObjectData,
  TUnits,
} from 'modules/accommodations/features/reservations/models';

export const oneUnitPerObject = (
  prevStateDeepCopy: IReservationObjectData[],
  clickedElementIndex: number,
  itemId: string,
) => {
  const checkOneUnitPerObject = prevStateDeepCopy.map((object: IReservationObjectData) => {
    return {
      ...object,
      units: object?.units?.map((unit: TUnits) => {
        return { ...unit, checked: false };
      }),
    };
  });

  const updatedUnits = checkOneUnitPerObject[clickedElementIndex]?.units.map((unit: TUnits) => {
    if (unit.unitId === itemId) {
      return { ...unit, checked: !unit.checked };
    }

    return { ...unit, checked: false };
  });

  checkOneUnitPerObject[clickedElementIndex] = {
    ...checkOneUnitPerObject[clickedElementIndex],
    units: updatedUnits,
  };

  return checkOneUnitPerObject;
};

export const moreUnitsPerObject = (
  prevStateDeepCopy: IReservationObjectData[],
  currentObject: IReservationObjectData,
  clickedElementIndex: number,
  itemId: string,
) => {
  const checkMoreUnitPerObject = prevStateDeepCopy.map((object: IReservationObjectData) => {
    if (object.propertyName === currentObject.propertyName) {
      return object;
    } else {
      return {
        ...object,
        units: object?.units?.map((unit: TUnits) => {
          return { ...unit, checked: false };
        }),
      };
    }
  });

  const updatedUnits = checkMoreUnitPerObject[clickedElementIndex]?.units.map((unit: TUnits) => {
    if (unit.unitId === itemId) {
      return { ...unit, checked: !unit.checked };
    }

    return unit;
  });

  checkMoreUnitPerObject[clickedElementIndex] = {
    ...checkMoreUnitPerObject[clickedElementIndex],
    units: updatedUnits,
  };

  return checkMoreUnitPerObject;
};

export const moreUnitsMoreObjects = (
  prevStateDeepCopy: IReservationObjectData[],
  clickedElementIndex: number,
  itemId: string,
) => {
  const updateUnits = prevStateDeepCopy[clickedElementIndex]?.units.map((unit: TUnits) => {
    if (unit.unitId === itemId) {
      return { ...unit, checked: !unit.checked };
    }

    return unit;
  });

  prevStateDeepCopy[clickedElementIndex] = {
    ...prevStateDeepCopy[clickedElementIndex],
    units: updateUnits,
  };

  return prevStateDeepCopy;
};
